module.exports = __webpack_public_path__ + "b0f93bc398634c450230c04bd74669f9.svg";